import {Component, OnInit} from "@angular/core";
import {UserService} from "../services/users.service";
import {ActivatedRoute, Router} from "@angular/router";
import {UserDto} from "../../../models/user-dto";
import {HttpErrorResponse} from "@angular/common/http";
import {Auth2Service} from "../../../services/auth2.service";
import {ApiService} from "../../../services/api.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-edit-consultant-user',
  templateUrl: './edit-consultant-user.component.html',
  styleUrls: ['./edit-consultant-user.component.scss'],
  standalone: false
})
export class EditConsultantUserComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'https://www.scalanthropy.com/'},
    { label: 'Home', path: 'https://www.scalanthropy.com/'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Edit Consultant Profile'}
  ];

  showMessages: boolean = false;
  messages: any[] = [];

  showSuccessMessages: boolean = false;
  successMessages: any[] = [];

  statesList: any[] = [];
  causeDropdownList: any[] = [];

  profileName = 'Edit Consultant Profile';
  savedUserId = '';
  savedUsername: string = '';
  savedPassword: string = '';
  savedFirstName: string = '';
  savedLastName: string = '';
  savedPhoneNumber: string = '';
  savedEmail:string = '';
  savedEIN: string = '999999999';
  savedCompanyName: string = '';
  //Physical Address for Stripe Integration
  savedAddressLine1: string = '';
  savedAddressLine2: string = '';
  savedAddressLine3: string = '';
  savedCity: string = '';
  savedState: string = '';
  savedCountry: string = '';
  savedZipCode: string = '';
  savedCause: string = 'CONSULTING';
  savedConsultantId: number = -1;
  savedIsConsultingFlag: boolean = false;
  savedJobTitle: string = '';
  savedConsultantAutoRenewal: string = 'Y';
  savedInvitedByClientBeforeJoining: string = 'N';
  username: string = '';

  registerBulkUsersWebUrl: string = '';

  // @ts-ignore
  constructor(private userService: UserService,
              private router: Router,
              private route: ActivatedRoute,
              private auth2Service: Auth2Service,
              private apiService: ApiService,
              private titleService: Title) {
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    this.populateUSAStates();
    this.titleService.setTitle("Scalanthropy Edit Consultant Profile");
    this.savedUserId = this.auth2Service.getUserId();
    this.username = this.auth2Service.getUsername();
    this.profileName = 'Edit Consultant Profile';
    // @ts-ignore
    this.userService.getConsultantUserV3(this.username)
      .subscribe((result: any) => {
        if (result && result.body) {
          this.populateData(result.body)
        }
        }, (error: HttpErrorResponse) => {
          if (error.status == 401) {
            this.messages.push({
              field: 'Get Profile Error',
              detail: 'You have logged out due to session being invalid. ' + error.error.message,
              severity: 'error'
            });
            this.showMessagesToUser();
            this.router.navigateByUrl('app/login');
          }
        })

  }

  private populateData(consultantUserDto: any) {
    if (consultantUserDto.userDto.userId) {
      this.savedUserId = consultantUserDto.userDto.userId;
    }

    if (consultantUserDto.userDto.firstName) {
      this.savedFirstName = consultantUserDto.userDto.firstName;
      const firstNameEl = document.getElementById('first-name-text-id');
      // @ts-ignore
      firstNameEl.value = this.savedFirstName;
    }

    if (consultantUserDto.userDto.lastName) {
      this.savedLastName = consultantUserDto.userDto.lastName;
      const lastNameEl = document.getElementById('last-name-text-id');
      // @ts-ignore
      lastNameEl.value = this.savedLastName;
    }

    if (consultantUserDto.userDto.email) {
      this.savedEmail = consultantUserDto.userDto.email;
      const emailEl = document.getElementById('email-text-id');
      // @ts-ignore
      emailEl.value = this.savedEmail;
    }

    if (consultantUserDto.userDto.phoneNumber) {
      this.savedPhoneNumber = consultantUserDto.userDto.phoneNumber;
      const phoneNumberEl = document.getElementById('phone-number-text-id');
      // @ts-ignore
      phoneNumberEl.value = this.savedPhoneNumber;
    }

    if (consultantUserDto.userDto.nonprofitDonorEin) {
      this.savedEIN = consultantUserDto.userDto.nonprofitDonorEin;
    }

    if (consultantUserDto.userDto.companyName) {
      this.savedCompanyName = consultantUserDto.userDto.companyName;
    }

    if (consultantUserDto.userDto.username) {
      this.savedUsername = consultantUserDto.userDto.username;
    }

    if (consultantUserDto.userDto.addressLine1) {
      this.savedAddressLine1 = consultantUserDto.userDto.addressLine1;
    }

    if (consultantUserDto.userDto.addressLine2) {
      this.savedAddressLine2 = consultantUserDto.userDto.addressLine2;
    }

    if (consultantUserDto.userDto.addressLine3) {
      this.savedAddressLine3 = consultantUserDto.userDto.addressLine3;
    }

    if (consultantUserDto.userDto.city) {
      this.savedCity = consultantUserDto.userDto.city;
    }

    if (consultantUserDto.userDto.state) {
      this.savedState = consultantUserDto.userDto.state;
      const stateEl = document.getElementById('usa-dropdown-list-id');
      // @ts-ignore
      stateEl.value = this.savedState;
    }

    if (consultantUserDto.userDto.country) {
      this.savedCountry = consultantUserDto.userDto.country;
    }

    if (consultantUserDto.userDto.zipCode) {
      this.savedZipCode = consultantUserDto.userDto.zipCode;
    }

    if (consultantUserDto.userDto.cause) {
      this.savedCause = consultantUserDto.userDto.cause;
    }

    if (consultantUserDto.userDto.consultantAutoRenewal) {
      this.savedConsultantAutoRenewal = consultantUserDto.userDto.consultantAutoRenewal;
    }

    if (consultantUserDto.invitedByClientBeforeJoining) {
      this.savedInvitedByClientBeforeJoining = consultantUserDto.invitedByClientBeforeJoining;
    }

    this.savedConsultantId = consultantUserDto.consultantId;

    if (consultantUserDto.jobTitle) {
      this.savedJobTitle = consultantUserDto.jobTitle;
      const jobTitleEl = document.getElementById('job-title-text-id');
      // @ts-ignore
      jobTitleEl.value = this.savedJobTitle;
    }
  }

  populateUSAStates(): void {
    this.statesList = [];
    this.userService.getUSAStatesDropdown().subscribe((result: any) => {
      if (result && result.body) {
        let i: number = 0;
        while (i < result.body.length) {
          this.statesList.push(result.body[i]);
          i = i + 1;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.messages.push({
        field: 'Failed to pull the States List',
        detail: 'Failed to pull the states list.',
        severity: 'error'
      });
      this.showMessagesToUser();
    })
  }

  onCancel(): void {
    this.router.navigateByUrl(this.savedUserId ? 'app/users/dashboard' : 'app/login');
  }

  showMessagesToUser(delayTime: number = 8000): void {
    this.showMessages = true;
    const counterFn = () => {
      this.showMessages = false;
    }
    setTimeout(counterFn, delayTime);
  }

  onSave(): void {
    this.showMessages = false;
    this.showSuccessMessages = false;
    this.messages = [];
    this.successMessages = [];
    //Validate First Name
    const firstNameEl = document.getElementById('first-name-text-id');
    // @ts-ignore
    let firstName = firstNameEl.value;
    if (!firstName) {
      this.messages.push({
        field: 'First Name',
        detail: 'First Name: ' + firstName + ' must not be empty.',
        severity: 'error'
      });
    }
    firstName = this.apiService.trimLeadingTrailingSpaces(firstName)
    if (firstName && firstName.length < 2 && firstName.length > 50) {
      this.messages.push({
        field: 'First Name',
        detail: 'First Name: ' + firstName + ' is not valid. The First Name must be 2 between 40 alphabetical characters, including dashes and spaces.',
        severity: 'error'
      })
    }
    this.savedFirstName = firstName;

    //Validate Last Name
    const lastNameEl = document.getElementById('last-name-text-id');
    // @ts-ignore
    let lastName = lastNameEl.value;
    if (!lastName) {
      this.messages.push({
        field: 'Last Name',
        detail: 'Last Name: ' + lastName + ' must not be empty.',
        severity: 'error'
      });
    }
    lastName = this.apiService.trimLeadingTrailingSpaces(lastName);
    if (lastName && lastName.length < 2 && lastName.length > 50) {
      this.messages.push({
        field: 'Last Name',
        detail: 'Last Name: ' + lastName + ' is not valid. The Last Name must be 2 between 40 alphabetical characters, including dashes and spaces.',
        severity: 'error'
      })
    }
    this.savedLastName = lastName;

    //Validate email
    const emailEl = document.getElementById('email-text-id');
    // @ts-ignore
    const email = emailEl.value;
    if (!email) {
      this.messages.push({
        field: 'Email',
        detail: 'Email: ' + email + ' is not valid.',
        severity: 'error'
      })
    }
    this.savedEmail = this.apiService.trimLeadingTrailingSpaces(email);

    //Validate Phone Number
    const phoneNumberEl = document.getElementById('phone-number-text-id');
    // @ts-ignore
    const phoneNumber = phoneNumberEl.value;
    if (!phoneNumber) {
      this.messages.push({
        field: 'Phone Number',
        detail: 'Phone Number: ' + phoneNumber + ' must not be empty.',
        severity: 'error'
      })
    }
    let modPhoneNumber: string = phoneNumber.replaceAll("-", "");
    modPhoneNumber = modPhoneNumber.replaceAll(" ", "");
    modPhoneNumber = modPhoneNumber.replaceAll("(", "");
    modPhoneNumber = modPhoneNumber.replaceAll(")", "");
    if (modPhoneNumber && modPhoneNumber.length != 10) {
      this.messages.push({
        field: 'Phone Number',
        detail: 'Phone Number: ' + phoneNumber + ' is not valid. The Phone Number must be exactly 10 digits and must be a US phone number.',
        severity: 'error'
      })
    }
    this.savedPhoneNumber = modPhoneNumber;

    //Validate Company Name
    const companyNameEl = document.getElementById('company-name-text-id');
    // @ts-ignore
    const companyName = companyNameEl.value;
    if (!companyName) {
      this.messages.push({
        field: 'Company Name',
        detail: 'Company Name: ' + companyName + ' is not valid.',
        severity: 'error'
      })
    }
    this.savedCompanyName = this.apiService.trimLeadingTrailingSpaces(companyName);

    //Validate Physical Address
    //Address Line 1
    const addressLine1El = document.getElementById('address-line-1-text-id');
    // @ts-ignore
    const addressLine1: string = addressLine1El.value;
    if (!addressLine1) {
      this.messages.push({
        field: 'AddressLine1',
        detail: 'AddressLine1: ' + addressLine1 + ' is not valid and must not be empty.',
        severity: 'error'
      })
    }
    this.savedAddressLine1 = this.apiService.trimLeadingTrailingSpaces(addressLine1);

    const addressLine2El = document.getElementById('address-line-2-text-id');
    // @ts-ignore
    const addressLine2: string = addressLine2El.value;
    this.savedAddressLine2 = addressLine2

    //const addressLine3El = document.getElementById('address-line-3-text-id');
    // @ts-ignore
    const addressLine3: string = '';
    this.savedAddressLine3 = addressLine3

    const cityEl = document.getElementById('city-text-id');
    // @ts-ignore
    const city = cityEl.value;
    if (!city) {
      this.messages.push({
        field: 'City',
        detail: 'City: ' + city + ' must not be empty.',
        severity: 'error'
      })
    }
    this.savedCity = this.apiService.trimLeadingTrailingSpaces(city);

    const stateEl = document.getElementById('usa-dropdown-list-id');
    // @ts-ignore
    const state: string = stateEl.value;
    if (!state) {
      this.messages.push({
        field: 'State',
        detail: 'State: ' + state + ' must not be empty.',
        severity: 'error'
      })
    }
    this.savedState = this.apiService.trimLeadingTrailingSpaces(state);

    const countryEl = document.getElementById('country-text-id');
    // @ts-ignore
    const country = countryEl.value;
    if (!country) {
      this.messages.push({
        field: 'Country',
        detail: 'Country: ' + country + ' must not be empty.',
        severity: 'error'
      })
    }
    this.savedCountry = this.apiService.trimLeadingTrailingSpaces(country);

    const jobTitleEl = document.getElementById('job-title-text-id');
    // @ts-ignore
    const jobTitle = jobTitleEl.value;
    if (!jobTitle) {
      this.messages.push({
        field: 'Job Title',
        detail: 'Job Title: ' + jobTitle + ' must not be empty.',
        severity: 'error'
      })
    }
    this.savedJobTitle = this.apiService.trimLeadingTrailingSpaces(jobTitle);

    const zipCodeEl = document.getElementById('zip-code-text-id');
    // @ts-ignore
    let zipCode: string = zipCodeEl.value;
    if (!zipCode) {
      this.messages.push({
        field: 'Zip Code',
        detail: 'Zip code: ' + zipCode + ' must not be empty.',
        severity: 'error'
      });
    } else {
      zipCode = zipCode.replace("-", "");
      zipCode = this.apiService.trimLeadingTrailingSpaces(zipCode)
      if (zipCode.length != 5 && zipCode.length != 9) {
        this.messages.push({
          field: 'Zip Code',
          detail: 'Zip code: ' + zipCode + ' can only be 5 digits or 9 digits.',
          severity: 'error'
        });
      }
    }
    this.savedZipCode = zipCode;
    if (this.messages.length > 0 ) {
      this.showMessagesToUser();
      return;
    }

    let userId = -1;
    if (this.savedUserId) {
      userId = parseInt(this.savedUserId);
    }

    let userDto: UserDto = {
      "userId": userId,
      "username": this.savedEmail,
      "password": '',
      "pwhash": '',
      "firstName": this.savedFirstName,
      "lastName": this.savedLastName,
      "phoneNumber": this.savedPhoneNumber,
      "email": this.savedEmail,
      "nonprofitDonorEin": this.savedEIN,
      "companyName": this.savedCompanyName,
      "isConsultant": 'Y',
      "addressLine1": this.savedAddressLine1,
      "addressLine2": this.savedAddressLine2,
      "addressLine3": this.savedAddressLine3,
      "city": this.savedCity,
      "state": this.savedState,
      "country": this.savedCountry,
      "zipCode": this.savedZipCode,
      "additionalUsernames": [],
      "cause": "CONSULTING",
      "consultantId": -1,
      "consultantEmail": "",
      "consultantReferralCode": "",
      "consultantReferralCodeVerified": "",
      "consultantRoleName": "",
      "consultantDisplayRoleName": "",
      "consultantAutoRenewal": this.savedConsultantAutoRenewal
    };
    let userConsultantDto: any = {
      userDto: userDto,
      consultantId: this.savedConsultantId,
      jobTitle: this.savedJobTitle,
      invitedByClientBeforeJoining: this.savedInvitedByClientBeforeJoining
    }

    //update user profile via API
    this.userService.editConsultantUserV3(userConsultantDto, this.username).subscribe((result: any) => {
        if (result && result.body) {
          this.router.navigateByUrl('app/users/dashboard');
        }
      }, (err: HttpErrorResponse) => {
        const errorList: string[] = err.error.errors;
        let i: number = 0;
        while (i < errorList.length) {
          this.messages.push({
            field: 'Consultant User Username Update Error',
            detail: errorList[i],
            severity: 'error'
          });
          i = i + 1;
        }
        this.showMessagesToUser();
      });

  }
}
